var SCM = SCM || {};

(function (SolrSearch, $, undefined) {

    // ----
    // private variables and functions
    // ----
    var bodyVar = $('body');
    var hfParentSiteName = $('.hfParentSiteName');
    var queryText = '';
    var topicsFacetVal = $('#js-topics-facet').val() || 'f_SemanticFilterTopics';
    var baseSiteURL = $('#hfSiteURL');

    function reannounceSearchResults() {
        var $alerts = $('.sr-alert-noresults[role="alert"], .sr-statistics[role="alert"]');
        if ($alerts.length) {
            $alerts.removeAttr('role');
            setTimeout(function () { $alerts.attr('role', 'alert'); }, 100);
        }
    }

    function setSolrDefaultBaseSiteUrl() {
        if (typeof baseSiteURL !== 'undefined' && baseSiteURL.val() !== '') {
            SCM.SearchResults.defaults.baseSiteUrl = baseSiteURL.val();
        }
    }

    // Used in both iconClickSearch() and keydownSearch()
    function _testSearchInput(inputToTest) {
        if (hfParentSiteName.val() !== '') {
            doSolrSearch(inputToTest);
        } else {
            //search term should not be blank
            if ($.trim(inputToTest) === '' || inputToTest === null || inputToTest === 'Search') {
                alert('Please enter a term to search: ');
                return false;
            } else if (inputToTest) {
                doSolrSearch(inputToTest);
                return true;
            } else {
                alert('SCM.SolrSearch.testSearchInput() fail');
                return false;
            }
        }
    }

    function _testKeypress(e, inputToPass) {
        if (e.key === 'Enter') {
            e.preventDefault();
            _testSearchInput(inputToPass);
        }
    }

    function doSolrSearch(inquiry, queryParam) {
        var customQueryParam = queryParam;
        if (!customQueryParam) {
            queryParam = 'q';
        }

        queryText = encodeURIComponent($.trim(inquiry));

        var quickSearchUrl = $('.hfQuickSearchUrl').val();
        var searchUrl = '';
        if (quickSearchUrl && !customQueryParam) {
            searchUrl = quickSearchUrl.replace('{searchQuery}', queryText);
            if (linksToExternalPage(searchUrl)) {
                window.open(searchUrl, '_blank');
            } else {
                window.location = searchUrl;
            }
            
        } else {
            //STATS:instead of passing in all the Journal IDs, just pass allJournals=1 in the querystring            var journalIdParms = "&allJournals=1";
            searchUrl = 'search-results?page=1&' + queryParam + '=' + queryText + '&SearchSourceType=1';

            var hfSiteURL = $('#hfSiteURL');
            if (hfSiteURL.length) {
                searchUrl = '//' + hfSiteURL.val() + '/' + searchUrl;
            }
            window.location.href = searchUrl;
        }

    } // END: doSolrSearch(inquiry, journalId)


    function linksToExternalPage(linkHref) {
        if (linkHref.startsWith('/')) {
            return false;
        }

        var hostRegEx = new RegExp('/' + window.location.host + '/');
        return !hostRegEx.test(linkHref);
    }

    function initDateRangeToggle() {
        $('.date-range-input-radio').off('click.date-range').on('click.date-range', function () {
            if ($(this).attr('value') === 'single') {
                $('.date-input-to').hide();
                $('.date-label-from span').text('Search on this date');
            } else {
                $('.date-input-to').show();
                $('.date-label-from span').text('From');
            }
        });
    }

    function _saveSolrSearchInfo(solrSearchSaveModel) {
        let solrSearchName = $('.txtSolrSearchName').val();
        let trimmedSearchName = solrSearchName.trim();
        var ddlSearchAlertFrequency = $('#ddlSearchAlertFrequency');
        var redirectUrl = $('#hdnSearchSaveRedirectUrl');
        var currentUrl = window.location.href;
        var ajaxUrl = (App.CurrentSubdomain.length ? '/' + App.CurrentSubdomain : '') + '/Solr/SaveSolrSearchInfo';
        var data = {
            searchName: trimmedSearchName,
            url: currentUrl,
            scheduleId: ddlSearchAlertFrequency.val(),
            redirectUrl: redirectUrl.val()
        };

        if (!trimmedSearchName) {
            alert('Please enter a name');
            return false;
        }

        SCM.Ajax.post(ajaxUrl, data)
            .expectActionResultModel()
            .ensureSuccess()
            .then(_handleAjaxSuccess)
            .catch(console.error);

        function _handleAjaxSuccess(result) {
            if (result.RedirectUrl && result.RedirectUrl.length) {
                window.location = result.RedirectUrl;
            } else {
                alert(result.Html);
                $(solrSearchSaveModel).closest('.reveal-modal').removeClass('open');
                $('body').removeClass('on-canvas');
            }
        }
    }

    function buildSaveSearchUiEvent() {
        var lnkSaveSolrSearch = $('.lnkSaveSolrSearch'),
            solrSearchSaveModel = $('.solrSearchSaveModel'),
            btnSolrSearchSave = $('.btnSolrSearchSave'),
            txtSolrSearchName = $('.txtSolrSearchName');

        // save solr search. Unbind event before register click event to prevent multiple clicks.
        lnkSaveSolrSearch.off('click').on('click', function () {
            var isUserLoggedIn = $(this).attr('data-userloggedin');
            if (isUserLoggedIn !== undefined && isUserLoggedIn.toLowerCase() === 'false') {
                var redirectUrl = $('#hdnSearchSaveRedirectUrl');
                var currentUrl = window.location.href;
                window.location = redirectUrl.val() + '?returnUrl=' + encodeURIComponent(currentUrl + '#triggerSaveSearch=1');
            } else {
                _openSaveSearchModal(solrSearchSaveModel);
            }
        });
        btnSolrSearchSave.off('click').on('click', function () {
            _saveSolrSearchInfo(solrSearchSaveModel);
        });
        txtSolrSearchName.off('keypress').on('keypress', function (e) {
            if (e.key === 'Enter') {
                _saveSolrSearchInfo(solrSearchSaveModel);
            }
        });
    }

    function _openSaveSearchModal($modal) {
        $modal.each(function () {
            _observeOpenStateToSyncAriaHidden(this);
        });
        $modal.attr('aria-hidden', 'false');
        SCM.Utilities.Reveal.open($modal, true);
    }

    // Attached at first open so it runs after Reveal's observer, which returns focus to the trigger when it can (SCMP-38752).
    function _observeOpenStateToSyncAriaHidden(modal) {
        const $modal = $(modal);
        if ($modal.data('ariaHiddenObserverAttached')) {
            return;
        }
        $modal.data('ariaHiddenObserverAttached', true);

        const observer = new MutationObserver(function () {
            const ariaHiddenForOpenState = $modal.hasClass('open') ? 'false' : 'true';
            if ($modal.attr('aria-hidden') !== ariaHiddenForOpenState) {
                if (ariaHiddenForOpenState === 'true' && modal.contains(document.activeElement)) {
                    document.activeElement.blur();
                }
                $modal.attr('aria-hidden', ariaHiddenForOpenState);
            }
        });
        observer.observe(modal, { attributes: true, attributeFilter: ['class', 'aria-hidden'] });
    }


    function restrictedImagesSearch() {
        $('div.sri-figure[restricted]').each(function () {
            $(this).off('contextmenu').on('contextmenu', function () { return false; });
        });
    }

    function updateMapResultsButtons() {
        if (window.location.pathname.indexOf('map-results') > 0) {
            $('#btnViewResultsInSearch').removeClass('hide');
            $('#btnViewResultsInMapResults').addClass('hide');
        }
    }

    function viewResultsOnMap() {
        $('body').on('click', '#btnViewResultsInMapResults', function () {
            var search = location.search.substring(1);

            if (SCM.SearchResults.defaults.baseSiteUrl !== '') {
                location.href = '//' + baseSiteURL.val() + '/map-results?' + search;
            }
        });
    }

    function viewResultsInSearch() {
        $('body').on('click', '#btnViewResultsInSearch', function () {
            var search = location.search.substring(1);

            if (SCM.SearchResults.defaults.baseSiteUrl !== '') {
                location.href = '//' + baseSiteURL.val() + '/search-results?' + search;
            }
        });
    }

    function listenForTaxonomyLabelClick() {
        $('body').on('click', '.taxonomy-label', function () {
            var currentDataUrl = $('#TaxonomyCurrentDataUrl').val();
            currentDataUrl = decodeURIComponent(currentDataUrl);

            //check if this is the root node (for now, we're not executing any query for root node)
            var rootNodeSelectedId = $(this).attr('data-parentid');
            if (rootNodeSelectedId === '') {
                return;
            }

            //get root node
            var rootNodeId = $('.taxonomy-node').attr('data-id');

            //selected taxonomy node
            var curTaxonomyNodeId = $(this).parent('.taxonomy-label-wrap').attr('data-id');

            //check if any taxonomy filters have been applied already.
            var taxQsPos = currentDataUrl.indexOf('tax');
            var taxQsPresent = taxQsPos === -1 ? false : true;

            if (!taxQsPresent) {
                //filter applied for the first time.
                currentDataUrl += '&tax=' + curTaxonomyNodeId;

            } else {
                //taxonomy filter applied previously
                var taxQueryTerm = currentDataUrl.substring(taxQsPos);
                var taxQueryTermEnd = taxQueryTerm.indexOf('&');
                if (taxQueryTermEnd > -1) {
                    taxQueryTerm = taxQueryTerm.substring(0, taxQueryTermEnd);
                }
                if (taxQueryTerm !== null && taxQueryTerm !== '') {
                    //check if taxonomy query was executed via Subject Dropdown, which is based on the rootNode.
                    if (taxQueryTerm.indexOf('=' + rootNodeId) > -1) {
                        //remove the root node and just use the selected node to expedite the query execution
                        currentDataUrl = currentDataUrl.replace(taxQueryTerm, 'tax=' + curTaxonomyNodeId);

                    }
                    else if ($.inArray(curTaxonomyNodeId, decodeURIComponent(taxQueryTerm.slice(4)).split(',')) === -1) {
                        //taxonomy query was executed from the facet section and has not already been selected
                        var newQuery = taxQueryTerm + ',' + curTaxonomyNodeId;
                        currentDataUrl = currentDataUrl.replace(taxQueryTerm, newQuery);
                    }
                }
            }

            SCM.SearchResults.doSolrSearch({ queryString: currentDataUrl, source: 'searchresults' });
        });
    }

    function handleExternalSearchLink() {
        $('body').on('click', '.js-facet-ext-link', function () {
            var currentUrl = window.location.href;
            if (currentUrl.indexOf('q=') >= 0) {
                var queryText = SCM.Common.getQueryStringValue(currentUrl, 'q');
                var linkUrl = $(this).data('url');
                if (linkUrl.length) {
                    if (!queryText.length || queryText === '*') {
                        queryText = '';
                    }
                    window.open(linkUrl.replace('{searchQuery}', queryText), '_blank');
                }
            }
        });
    }

    function bindUiEvents() {
        var $micrositeSearchIcon = $('.master-header').find('.microsite-search-icon'),
            $micrositeSearchTerm = $('.master-header').find('.microsite-search-term'),
            $mobileMicrositeSearchIcon = $('.master-header').find('.mobile-microsite-search-icon'),
            $mobileMicrositeSearchTerm = $('.master-header').find('.mobile-microsite-search-term'),
            $toolbarSearchIcon = $('.toolbar-search').find('.microsite-search-icon'),
            $toolbarSearchTerm = $('.toolbar-search').find('.microsite-search-term'),
            $umbrellaSearchIcon = $('#UmbrellaSearchIcon'), // icon
            $umbrellaHomeSearchIcon = $('#UmbrellaHomeSearchIcon'), // home icon
            $umbrellaSearchTerm = $('#UmbrellaSearchTerm'), // term 
            $umbrellaHomeSearchTerm = $('#UmbrellaHomeSearchTerm'), // home term
            $articleKeywordSearchTerm = $('.kwd-part'), // article page keyword term            
            $quickSearchSelectMobile = $('.navbar-search-filter-mobile'),
            $quickSearchSelectSite = $('.navbar-search-filter-site'),
            $quickSearchUrl = initQuickSearchUrl($quickSearchSelectSite, $quickSearchSelectMobile);

        // Searches performed when a search icon is clicked
        $umbrellaSearchIcon.on('click', function () { _testSearchInput($umbrellaSearchTerm.val()); });
        $umbrellaHomeSearchIcon.on('click', function () { _testSearchInput($umbrellaHomeSearchTerm.val()); });
        $micrositeSearchIcon.on('click', function () { _testSearchInput($micrositeSearchTerm.val()); });
        $mobileMicrositeSearchIcon.on('click', function () { _testSearchInput($mobileMicrositeSearchTerm.val()); });
        $toolbarSearchIcon.on('click', function () { _testSearchInput($toolbarSearchTerm.val()); });

        $('.searchLi .icon-search').on('click', function () { _testSearchInput($micrositeSearchTerm.val()); });
        $articleKeywordSearchTerm.on('click', function () { _testSearchInput($(this).attr('data-keyword')); });

        // Searches performed when 'Enter' is pressed
        $umbrellaSearchTerm.on('keypress', function (e) { _testKeypress(e, $umbrellaSearchTerm.val()); });
        $umbrellaHomeSearchTerm.on('keypress', function (e) { _testKeypress(e, $umbrellaHomeSearchTerm.val()); });
        $micrositeSearchTerm.on('keypress', function (e) { _testKeypress(e, $micrositeSearchTerm.val()); });
        $mobileMicrositeSearchTerm.on('keypress', function (e) { _testKeypress(e, $mobileMicrositeSearchTerm.val()); });
        $toolbarSearchTerm.on('keypress', function (e) { _testKeypress(e, $toolbarSearchTerm.val()); });

        $quickSearchSelectMobile.on('change', function () {
            sessionStorage.setItem('quickSearchUrlVal', $(this).val());
            $quickSearchUrl.val($(this).val());
            normalizeSelectedIndices($(this).prop('selectedIndex'));
        });

        $quickSearchSelectSite.on('change', function () {
            sessionStorage.setItem('quickSearchUrlVal', $(this).val());
            $quickSearchUrl.val($(this).val());
            normalizeSelectedIndices($(this).prop('selectedIndex'));                
        });

        $('.master-main').on('click', '.showAbstractLink', function () {
            $(this).closest('.sri-abstract-link').toggleClass('expanded');
            $(this).closest('.sri-abstract-link').find('.abstract-response-placeholder').toggleClass('hide');
        });
    }

    function initQuickSearchUrl($siteSelectFilter, $mobileSelectFilter) {
        var quickSearchUrl = $('.hfQuickSearchUrl');
        var sessionQuickSearchVal = sessionStorage.getItem('quickSearchUrlVal');
        if (sessionQuickSearchVal)
        {
            if ($siteSelectFilter.length &&
                $siteSelectFilter.find('option[value="' + sessionQuickSearchVal + '"]').length) {
                quickSearchUrl.val(sessionQuickSearchVal);
                $siteSelectFilter.find('option[value="' + sessionQuickSearchVal + '"]').prop('selected', true);
            } 

            if ($mobileSelectFilter.length &&
                $mobileSelectFilter.find('option[value="' + sessionQuickSearchVal + '"]').length) {
                quickSearchUrl.val(sessionQuickSearchVal);
                $mobileSelectFilter.find('option[value="' + sessionQuickSearchVal + '"]').prop('selected', true);
            }            
        }
        return quickSearchUrl;
    }

    function normalizeSelectedIndices(newIndex) {
        $('.navbar-search-filter-mobile, .navbar-search-filter-site').closest().prop('selectedIndex', newIndex);
    }

    function listenForFacetHeaderClick() {
        $('.js-main').on('click', '.collapsible-facet .sf-group-header', _toggleFacetList);
    }

    function _toggleFacetList(e) {
        if ($(window).outerWidth() < 1024) {
            var $currentTarget = $(e.currentTarget);
            var $facetHeaderIcon = $currentTarget.children('.sf-group-header-icon');

            $currentTarget.siblings('fieldset').children('.sf-facets, .sf-facet-list').slideToggle();
            $currentTarget.siblings('.taxonomy-node').slideToggle();
            $facetHeaderIcon.toggleClass('icon-general_arrow-down icon-general_arrow-right');
        }
    }

    function doSolrSearchOnClickOfSriTopicLink() {
        bodyVar.on('click', '.sriTopiclink', function (e) {
            queryText = $(this).text();
            var searchTerm = queryText.replace(',', '');
            doSolrSearch(searchTerm, topicsFacetVal);

            e.preventDefault();
        });
    }

    function doSolrSearchOnClickOfJsSriTopicLink() {
        bodyVar.on('click', '.js-sriTopic-link', function (e) {
            queryText = $(this).parent('.js-sriTopic-link-container').find('.js-sriTopic-link-categoryid').val();
            doSolrSearch(queryText, topicsFacetVal);

            e.preventDefault();
        });
    }

    function determineWhichSearchFunctionToUseInQueryBuilder() {
        if ($(SCM.SearchResults.defaults.updateTargetSelector).length > 0) {
            //we're on the search results page so all searches should call the search results search method
            SCM.QueryBuilder.defaults.runSearch = function (queryString) {

                SCM.SearchResults.doSolrSearch({
                    queryString: queryString,
                    source: 'searchresults',
                    callback: _handleSearchCompleteCallback
                });
            };
        } else {

            //configure querybuilder for advance search
            $('.querybuilder-submit').attr('value', 'Search');
            $('.querybuilder-title').text('Modify your search');

            SCM.QueryBuilder.defaults.runSearch = function (redirectUrl) {
                var searchSiteUrl = $('#hfSiteURL').val();
                if (redirectUrl.indexOf('q=') === -1) {
                    redirectUrl = 'q=' + redirectUrl;
                }
                window.location = window.location.protocol + '//' + searchSiteUrl + '/search-results?' + redirectUrl;
            };
        }
    }

    function _handleSearchCompleteCallback() {
        if (typeof App?.Search?.onSearchPageLoadComplete === 'function') {
            App.Search.onSearchPageLoadComplete();
        }
    }

    function initStopStickyLeftRailAtBottomOfPage() {
        var leftRailStickyElement = $('#divSearch').find('#InfoColumn').find('.info-inner-wrap-js');
        if (!(window.mozInnerScreenX == null) && leftRailStickyElement.length) {
            $(window).on('scroll', debounce(StopStickyLeftRailAtBottomOfPage, 100));
        }
    }

    var triggerStartStickyOffset = -1060;
    var triggerStopStickyOffset = -860;
    var triggerStartStopStickyOffset = triggerStopStickyOffset;

    function StopStickyLeftRailAtBottomOfPage() {
        var leftRailStickyElement = $('#divSearch').find('#InfoColumn').find('.info-inner-wrap-js');
        var endOfPageElement = $($('.end-of-page-js')[0]);
        if (leftRailStickyElement.length && endOfPageElement.length) {
            var currentScrollPosition = $(this).scrollTop();
            var endOfPagePosition = endOfPageElement.offset().top;
            if (currentScrollPosition < (endOfPagePosition + triggerStartStopStickyOffset)) {
                leftRailStickyElement.addClass('can-stick');
                triggerStartStopStickyOffset = triggerStopStickyOffset;
            } else {
                leftRailStickyElement.removeClass('can-stick');
                triggerStartStopStickyOffset = triggerStartStickyOffset;
            }
        }
     }

    // ----
    // public methods and properties accessible by SCM.[module_name].[method_name]
    // ----
    SolrSearch.init = function () {
        setSolrDefaultBaseSiteUrl();
        bindUiEvents();
        buildSaveSearchUiEvent();
        initDateRangeToggle();
        restrictedImagesSearch();
        doSolrSearchOnClickOfSriTopicLink();
        doSolrSearchOnClickOfJsSriTopicLink();
        handleExternalSearchLink();
        listenForFacetHeaderClick();
        listenForTaxonomyLabelClick();
        viewResultsOnMap();
        viewResultsInSearch();

        // configure Query Builder on page load
        SCM.QueryBuilder.configure();
        determineWhichSearchFunctionToUseInQueryBuilder();
        initStopStickyLeftRailAtBottomOfPage();

        reannounceSearchResults();
    }; // END: SolrSearch.init()

    SolrSearch.ajaxComplete = function (ajaxSettings) {
        reannounceSearchResults();
        buildSaveSearchUiEvent();
        initDateRangeToggle();
        restrictedImagesSearch();
        // Re-init lazy loading for images in replaced search results. The live AJAX path is also
        // covered by jQuery's global ajaxComplete, but the in-memory cache re-display path is not.
        SCM.Utilities.LazyLoad.init('lazy');
        SCM.QueryBuilder.configure();
        updateMapResultsButtons();
        SCM.SiteJS.initSearchResultsSort();
        SCM.PDFAccess.init();
        SCM.PageTitleHelper.SetDynamicPageTitle('#js-search-terms-page-title');
        SCM.BookPartTitleFacet.showAllItems();
        SCM.BookPartTitleFacet.toggleBookPartTitleParent();
        SCM.CollectionFacet.showAllItems();
        SCM.CollectionFacet.toggleCollectionParent();

        if (SCM.GoogleDoubleclickAds && typeof SCM.GoogleDoubleclickAds.Init === 'function') {
            var shouldInitAds = !SCM.filterExternalAjaxCompleteAdInit || _isInternalAjaxRequest(ajaxSettings);
            if (shouldInitAds) {
                // Destroy previously registered in-list ad slots before re-initializing,
                // otherwise GPT throws duplicate div ID errors after AJAX content replacement.
                if (typeof googletag !== 'undefined' && googletag.apiReady && googletag.destroySlots) {
                    var inListSlots = (googletag.pubads().getSlots() || []).filter(function (slot) {
                        return slot.getSlotElementId().indexOf('inlistAd_') === 0;
                    });
                    if (inListSlots.length) {
                        googletag.destroySlots(inListSlots);
                    }
                }
                SCM.GoogleDoubleclickAds.Init();
            }
        }
    };

    function _isInternalAjaxRequest(ajaxSettings) {
        var url = ajaxSettings && ajaxSettings.url || '';
        return url === '' ||
            (url.charAt(0) === '/' && url.charAt(1) !== '/') ||
            url.indexOf(window.location.host) !== -1;
    }

    SCM.SolrSearch.init();

})(SCM.SolrSearch = SCM.SolrSearch || {}, jQuery);

